define('uikit/views/table.ellipsis',['require','exports','module','underscore','./table.selected','../elements/dropdown'],function(require, exports, module){
  var _ = require('underscore');
  var TableSelectedView = require('./table.selected');
  var Dropdown = require('../elements/dropdown');

  var TableEllipsis = TableSelectedView.extend({

    options: _.extend({}, TableSelectedView.prototype.options, {
      collection : null
    }),

    forceUpdate: _.extend({}, TableSelectedView.prototype.forceUpdate, {
      collection: true
    }),

    ui: {
      icon: 'i.icon'
    },

    internalViewOptions: {
      view: function(){
        return {
          iconOnly: true,
          icon: 'ellipsis horizontal',
          pointing: 'left',
          mode: Dropdown.BUTTON_MODE,
          circular: true,
          bindings: this.bindings,
          inverted: this.inverted,
          type: Dropdown.extend({
            getChildView: function(model){
              var childType = Dropdown.prototype.getChildView.apply(this, arguments);

              return childType.extend({
                behaviors: model.get('behaviors')
              });
            }
          })
        }
      }
    },

    initialize: function() {
      TableSelectedView.prototype.initialize.apply(this, arguments);

      this.childBindings.text = 'text';
      this.childBindings.icon = 'icon';
      this.childBindings.link = 'link';
      this.view.childBindings = this.childBindings;
      this.bindOption('collection', 'collection', this.view);

      this.setupContextMenu();

      this.view.on('press', function() {
        var args = _.toArray(arguments),
            row  = this.getOption('rowView');

        this.triggerMethod.apply(this, ['action', this].concat(args));
        row.triggerMethod.apply(row, ['action'].concat(args))
      }, this);
    },

    onChangeCollection: function() {
      this.view.collection = this.collection;
    },

    setupContextMenu: function() {
      var row      = this.getOption('rowView'),
          dropdown = this.view,
          self     = this;

      function reposition(ev) {
        var dp            = dropdown.$el,
            menu          = dropdown.$el.find('.menu'),
            columnDp      = dp.closest('td'),
            columnClicked = $(ev.target),
            table         = columnClicked.closest('table'),
            topOffset     = 2 * parseInt(columnClicked.css('font-size')); // Used to calculate offset when in responsive view

        menu.css({
          top: ev.offsetY + columnClicked.offset().top - table.offset().top - columnClicked.closest('tr').position().top - topOffset,
          left: ev.offsetX + columnClicked.position().left - parseInt(columnDp.css('padding-left'))
        })
      }

      function setOriginalPosition() {
        dropdown.$el.find('.menu').css({
          top: '0%',
          left: '100%'
        });
      }

      dropdown.on('dropdown:hide', function() {
        // Must delay to allow for animation to finish, otherwise styles will reset
        setTimeout(function() {
          setOriginalPosition();
        }, 400)
      });

      // Reset position if clicking on button
      dropdown.$el
        .on('mousedown', function(ev) {
          var menuEl = dropdown.$el.find('.menu').get(0);

          self._menuClick = false;

          // Do not reposition, if clicking within menu
          if (!menuEl.contains(ev.target)) {
            setOriginalPosition();

          // Use flag to disable blur on menu click until after press event
          } else {
            self._menuClick = true;
          }
        })

      row.$el
        .on('contextmenu', function(ev) {
          var contextMenuEl = dropdown.$el,
              _contextMenu  = window._contextMenu;

          // Hide any opened context menus
          if (_contextMenu && _contextMenu.get(0) != contextMenuEl.get(0)) {
            _contextMenu.dropdown('hide');
          }

          // Cache the new context menu
          window._contextMenu = contextMenuEl;

          // Only applies if dropdown is visible
          if (!self.visible || (self.visible && self._menuClick)) {
            self._menuClick = false;
            return;
          }

          // Set focus to make sure blur is called
          row.$el.focus();

          // Reposition according to right click
          reposition(ev);

          // Don't hide the contextmenu, just reposition
          dropdown.$el.dropdown('show');

          return false;
        })
        .on('blur', function() {
          // Only blur if blur was not initiated by menu click
          if (self._menuClick) {
            return;
          }

          // Once you lose focus from the row, hide the dropdown
          dropdown.$el.dropdown('hide');
        });
    }

  });

  module.exports = TableEllipsis;
});

